// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Backorder # · Low to High'),
    value: { field: 'BACKORDER_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Backorder # · High to Low'),
    value: { field: 'BACKORDER_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Customer · A to Z'),
    value: { field: 'CUSTOMER', direction: 'ASC' },
  },
  {
    label: i18n.t('Customer · Z to A'),
    value: { field: 'CUSTOMER', direction: 'DESC' },
  },
  {
    label: i18n.t('Order # · Low to High'),
    value: { field: 'ORDER_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Order # · High to Low'),
    value: { field: 'ORDER_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Status · A to Z'),
    value: { field: 'STATUS', direction: 'ASC' },
  },
  {
    label: i18n.t('Status · Z to A'),
    value: { field: 'STATUS', direction: 'DESC' },
  },
  {
    label: i18n.t('Expected Date - Oldest'),
    value: { field: 'EXPECTED_DATE', direction: 'ASC' },
  },
  {
    label: i18n.t('Expected Date - Most Recent'),
    value: { field: 'EXPECTED_DATE', direction: 'DESC' },
  },
  {
    label: i18n.t('Last Updated - Oldest'),
    value: { field: 'UPDATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Last Updated - Most Recent'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Date Created - Oldest'),
    value: { field: 'CREATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Date Created - Most Recent'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
